import { null as zNull } from "zod";

export const disconnectTeamworkCommerceIntegration = {
  name: "disconnectTeamworkCommerceIntegration" as const,
  input: zNull(),
  output: zNull(),
};
